import React from 'react';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { LogoBcp } from '@icons';

export const LogoBcpPlaceholder: React.FC = () => {
	return (
		<Box
			styles={{
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<LogoBcp />
		</Box>
	);
};
